import { openBlock, createElementBlock } from "vue";
import _export_sfc from "../../../../_virtual/_plugin-vue_export-helper.mjs";
const _sfc_main = {};
function _sfc_render(_ctx, _cache) {
  return openBlock(), createElementBlock("p", null, " Like other retailers, we can set our own prices. Because we've priced this item below the manufacturer's recommendation, it needs to be in your cart before you can see the price. Sorry for the inconvenience. ");
}
const MapMessageModal = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  MapMessageModal as default
};
//# sourceMappingURL=MapMessageModal.mjs.map
